<template>
  <AutoForm :form="form" :schema="formSchema" :field-config="fieldConfig" @submit="onSubmit">
    <slot />
  </AutoForm>
</template>

<script lang="ts" setup>
import { useForm } from "vee-validate";
import { z } from "zod";
import type { ApiMcpServer } from "~/server/api/organizations/[organizationId]/mcpServers/types";
import type { ConfigItem } from "~/components/ui/auto-form";

const { t } = useI18n();

const props = defineProps<{
  initialValues?: ApiMcpServer;
}>();

const emit = defineEmits<{
  submit: [values: ApiMcpServer];
}>();

const form = useForm({
  initialValues: props.initialValues
});

const formSchema = z.object({
  name: z.string(),
  url: z.string(),
  authorizationHeader: z.string().optional(),
  isTrusted: z.boolean().default(false)
});

const fieldConfig: Record<string, ConfigItem> = {
  name: {
    label: t('settings.mcpServers.form.fields.name.label'),
    description: t('settings.mcpServers.form.fields.name.description')
  },
  url: {
    label: t('settings.mcpServers.form.fields.url.label'),
    description: t('settings.mcpServers.form.fields.url.description')
  },
  authorizationHeader: {
    label: t('settings.mcpServers.form.fields.authorizationHeader.label'),
    description: t('settings.mcpServers.form.fields.authorizationHeader.description')
  },
  isTrusted: {
    label: t('settings.mcpServers.form.fields.isTrusted.label'),
    description: t('settings.mcpServers.form.fields.isTrusted.description'),
    inputProps: {
      type: 'switch'
    }
  }
};

const onSubmit = async () => {
  emit("submit", form.values);
};
</script>
